import React, { useContext } from 'react';
import _ from 'lodash'; // eslint-disable-line

// Nucleus Components
import { ExperienceContext } from '@thd-nucleus/experience-context';

// Local Components
import { TimeslotForm } from '../../../components/timeslot-form/timeslot-form';
import { ReservationContext } from '../../../context/reservation-context';

import { LocationList } from '../../../components/location-list/location-list';
import { FormSection } from '../../../components/form-section/form-section';
import { AvailabilityStatusMessage } from '../../../components/availability-status-message/availability-status-message';
import helper from '../../../utils/helper';

import { useModifyAvailabilityData } from '../../../hooks/useModifyAvailabilityData';
import { CurrentTimes } from '../../../components/current-times/current-times';

// CSS
import '../reservation-modify-form.scss';

export const Flow = () => {

  const [reservationState, dispatch] = useContext(ReservationContext);

  const { activeSection } = reservationState;
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const {
    data,
    loading,
    executeRequest
  } = useModifyAvailabilityData();

  const checkAvailabilityHandler = () => {
    dispatch({ type: 'SET_ACTIVE_SECTION', payload: 'StoreCards' });
    executeRequest();
    if (isMobile) {
      helper.scrollToSection('StoreCards');
    }
  };

  return (
    <div className="modify-flow">
      <FormSection identifier="DaysAndTimes" display title="Current Days and Times">
        <CurrentTimes />
      </FormSection>
      <FormSection identifier="DaysAndTimes" display title="Modify Days and Times">
        <TimeslotForm
          checkAvailability={checkAvailabilityHandler}
        />
      </FormSection>
      <FormSection identifier="StoreCards" display={activeSection === 'StoreCards'} title="Current Location">
        <>
          <AvailabilityStatusMessage
            availabilityData={data}
            isLoading={loading}
          />
          <LocationList
            availabilityData={data}
            isLoading={loading}
          />
        </>
      </FormSection>
    </div>
  );
};

Flow.propTypes = {};
